/**
 * Datumhjälpfunktioner för aktuell tidpunkt.
 *
 * Fyra varianter med olika format beroende på användningsfall:
 *
 *   getDateTimeWithWeekday  — "dd-mm-yyyy hh:mm:ss Weekday"  (Overview, Support, AdminSupport)
 *   getDateTimeWithAmPm     — "yyyy-mm-dd hh:mm am/pm"       (AdminUpload)
 *   getDateTime             — "yyyy-mm-dd hh:mm"             (BuyCredit, ElementTag)
 *   getDateOnly             — "dd-mm-yyyy"                   (Upload)
 */

const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

const pad = (n) => (n < 10 ? '0' + n : n)

/**
 * Returnerar aktuell tidpunkt som "dd-mm-yyyy hh:mm:ss Weekday".
 * Används för tidsstämplar i chattmeddelanden.
 */
export function getDateTimeWithWeekday() {
  const d = new Date()
  const day     = pad(d.getDate())
  const month   = pad(d.getMonth() + 1)
  const year    = d.getFullYear()
  const hour    = pad(d.getHours())
  const minute  = pad(d.getMinutes())
  const second  = pad(d.getSeconds())
  const weekday = WEEKDAYS[d.getDay()]
  return `${day}-${month}-${year} ${hour}:${minute}:${second} ${weekday}`
}

/**
 * Returnerar aktuell tidpunkt som "yyyy-mm-dd hh:mm am/pm".
 * Används i AdminUpload för uppladdningstabellens tidsstämplar.
 */
export function getDateTimeWithAmPm() {
  const d      = new Date()
  const year   = d.getFullYear()
  const month  = pad(d.getMonth() + 1)
  const day    = pad(d.getDate())
  const hour   = pad(d.getHours())
  const minute = pad(d.getMinutes())
  const ampm   = d.getHours() >= 12 ? 'pm' : 'am'
  return `${year}-${month}-${day} ${hour}:${minute} ${ampm}`
}

/**
 * Returnerar aktuell tidpunkt som "yyyy-mm-dd hh:mm".
 * Används för betalnings- och kredithistorik-tidsstämplar.
 */
export function getDateTime() {
  const d      = new Date()
  const year   = d.getFullYear()
  const month  = pad(d.getMonth() + 1)
  const day    = pad(d.getDate())
  const hour   = pad(d.getHours())
  const minute = pad(d.getMinutes())
  return `${year}-${month}-${day} ${hour}:${minute}`
}

/**
 * Returnerar dagens datum som "dd-mm-yyyy" (utan tid).
 * Används i Upload-formuläret.
 */
export function getDateOnly() {
  const d     = new Date()
  const day   = pad(d.getDate())
  const month = pad(d.getMonth() + 1)
  const year  = d.getFullYear()
  return `${day}-${month}-${year}`
}
